import client from '../client';
import * as commodityGroupQueries from "../queries/commodityGroup";
import * as commodityGroupMutations from "../mutations/commodityGroup";

export function getCommodityGroups(success, error, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        query: commodityGroupQueries.all,
    })
    .then(success)
    .catch(error);
}


export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        variables: { id: id },
        fetchPolicy: fetchPolicy,
        query: commodityGroupQueries.get,
    })
        .then(success)
        .catch(error);
}


export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, commodityGroup: data },
        mutation: commodityGroupMutations.edit,
    })
    .then(success)
    .catch(error);
}


export function add(success, error, data) {
    client.mutate({
        variables: { commodityGroup: data },
        mutation: commodityGroupMutations.add,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/commodityGroup.js